import { useQuery } from '@tanstack/react-query';

import { SearchAutocompleteItem } from '../components/SearchAutocomplete';
import { resolveAvailabilitySlugItems } from '../utils/resolveAvailabilitySlugItems';

const EMPTY_SLUG_ITEMS: Record<string, SearchAutocompleteItem> = {};

export function useAvailabilitySlugItems(slugs: string[]) {
	const uniqueKey = Array.from(new Set(slugs)).sort().join(' ');
	const uniqueSlugs = uniqueKey ? uniqueKey.split(' ') : [];

	const query = useQuery({
		queryKey: ['availability-slug-items', uniqueKey],
		queryFn: () => resolveAvailabilitySlugItems(uniqueSlugs),
		enabled: uniqueSlugs.length > 0,
		staleTime: Infinity,
	});

	return {
		itemsBySlug: query.data ?? EMPTY_SLUG_ITEMS,
		isResolving: uniqueSlugs.length > 0 && query.data === undefined && !query.isError,
	};
}
